import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import DirectorExternalStatusModalUI from './DirectorExternalStatusModalUI.js'

class DirectorExternalStatusModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            submitted: false,
            status: '',
            statusError: null,
            reuploadMessage: '',
            reuploadMessageError: null,
            waivedMessage: '',
            waivedMessageError: null,
        }
    }

    componentDidMount() {
        Modal.setAppElement('body')
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.updateMode && this.props.updateMode) {
            this.setState({
                status: this.props.selectedDirectorStatus || '',
                statusError: null,
                reuploadMessage: '',
                reuploadMessageError: null,
                waivedMessage: '',
                waivedMessageError: null,
                errorList: null,
                successMsg: null,
                submitted: false,
            })
        }
    }

    // In render(), replace the return with:
    render() {
        const statusList = [
            { key: 'pending', value: 'Pending' },
            { key: 'to_be_reviewed', value: 'To Be Reviewed' },
            { key: 'complied', value: 'Complied' },
            { key: 'reviewed_and_requires_resubmission', value: 'Reviewed and Requires Resubmission' },
            { key: 'not_applicable', value: 'Not Applicable' },
            { key: 'waived', value: 'Waived' },
        ]

        return (
            <DirectorExternalStatusModalUI
                context={this.props.context}
                updateMode={this.props.updateMode}
                submitted={this.state.submitted}
                selectedDirectorName={this.props.selectedDirectorName}
                onSubmit={this.onSubmit}
                onCancelClick={this.props.onCancelClick}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={(list) => { this.setState({ errorList: list }) }}
                statusList={statusList}
                status={this.state.status}
                onStatusChange={(event) => {
                    this.setState({
                        status: event.target.value,
                        statusError: null,
                        reuploadMessage: '',
                        reuploadMessageError: null,
                        waivedMessage: '',
                        waivedMessageError: null,
                    })
                }}
                statusError={this.state.statusError}
                setStatusError={(error) => { this.setState({ statusError: error }) }}
                reuploadMessage={this.state.reuploadMessage}
                onReuploadMessageChange={(event) => { this.setState({ reuploadMessage: event.target.value }) }}
                reuploadMessageError={this.state.reuploadMessageError}
                setReuploadMessageError={(error) => { this.setState({ reuploadMessageError: error }) }}
                waivedMessage={this.state.waivedMessage}
                onWaivedMessageChange={(event) => { this.setState({ waivedMessage: event.target.value }) }}
                waivedMessageError={this.state.waivedMessageError}
                setWaivedMessageError={(error) => { this.setState({ waivedMessageError: error }) }}
            />
        )
    }

    onSubmit = () => {
        if (this.state.submitted) return

        if (!this.state.status) {
            this.setState({ statusError: 'Please select a status.' })
            return
        }
        if (this.state.status === 'reviewed_and_requires_resubmission' && !this.state.reuploadMessage.trim()) {
            this.setState({ reuploadMessageError: 'Please enter a resubmission reason.' })
            return
        }
        if (this.state.status === 'waived' && !this.state.waivedMessage.trim()) {
            this.setState({ waivedMessageError: 'Please enter a waived message.' })
            return
        }

        this.setState({ successMsg: null, errorList: [], submitted: true })

        RestApiUtils.put(
            this.props.context,
            `/api/su/loans/${this.props.loan.loanId}/compliances/${this.props.selectedFileCode}/users/${this.props.selectedUserId}/externalStatus`, this.onSubmitCallback,
            {
                status: this.state.status,
                reuploadMessage: this.state.reuploadMessage || null,
                waivedMessage: this.state.waivedMessage || null,
            }
        )
    }

    onSubmitCallback = (response) => {
        const errorList = (response.errorList || []).map(e => e.message)
        this.setState({ successMsg: response.success, errorList, submitted: false })
        if (errorList.length === 0) {
            setTimeout(() => {
                this.setState({ successMsg: null })
                this.props.onCancelClick()
                this.props.onRefreshClick('noBusy')
            }, 10)
        }
    }
}

export default withRouter(DirectorExternalStatusModalSF)